export default "__VITE_ASSET__B5d5rTS0__"